import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { APP_CONFIG, EnvironmentModel } from '@fh-client-interaction-frontends/fh-app-config';
import { map, Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { BackofficeContactsSetupModel } from '../../../helpers/objects/dto/backoffice/backoffice-contacts/backoffice-contacts-setup/backoffice-contacts-setup-model';
import { BackofficeContactsRequestModel } from '../../../helpers/objects/request/backoffice/backoffice-contacts/backoffice-contacts-request-model';
import { BackofficeContactsResponseModel } from '../../../helpers/objects/response/backoffice-contacts/backoffice-contacts-response-model';
import { BackofficeContactsModel } from '../../../helpers/objects/dto/backoffice/backoffice-contacts/backoffice-contacts/backoffice-contacts-model';

@Injectable({
  providedIn: 'root'
})
export class BackofficeContactsService {
  appConfig: EnvironmentModel = new EnvironmentModel();
  savedContactsSetup: BackofficeContactsSetupModel = new BackofficeContactsSetupModel();
  constructor(private http: HttpClient, @Inject(APP_CONFIG) protected appConfigTemp: EnvironmentModel) {
    this.appConfig = appConfigTemp;
  }

  setup(): Observable<BackofficeContactsSetupModel> {
    return this.http.get<any>(this.appConfig.api + 'backoffice/contacts/' + this.appConfig.apiPartnershipId + '/setup').pipe(
      map((response) => {
        this.savedContactsSetup = response.body as BackofficeContactsSetupModel;
        return response.body as BackofficeContactsSetupModel;
      })
    );
  }

  getContacts(filter: BackofficeContactsRequestModel): Observable<BackofficeContactsResponseModel> {
    const httpParams: HttpParams = new HttpParams({
      fromObject: filter as any
    });
    return this.setup().pipe(
      switchMap((contactsSetup) => {
        return this.http.get<any>(this.appConfig.api + 'backoffice/contacts/' + this.appConfig.apiPartnershipId, { params: httpParams }).pipe(
          map((response) => {
            response.body.contacts.forEach((item: any) => {
              if (item?.phones[0]?.phone && item?.phones[0]?.phoneCode) {
                item.phones = item?.phones[0]?.phoneCode + ' | ' + item?.phones[0]?.phone;
              }
              contactsSetup?.contactTypeList.forEach((profile: any) => {
                if (item.contactTypeId == profile.id) {
                  item.contactTypeId = profile.type;
                }
              });
            });
            return response.body as BackofficeContactsResponseModel;
          })
        );
      })
    );
  }

  getContactDetail(contactId: string): Observable<BackofficeContactsModel> {
    return this.http
      .get<any>(this.appConfig.api + 'backoffice/contacts/' + this.appConfig.apiPartnershipId + '/detail/' + contactId)
      .pipe(map((response) => response.body.contact as BackofficeContactsModel));
  }

  editContactDetail(data: BackofficeContactsModel): Observable<any> {
    return this.http.put<any>(this.appConfig.api + 'backoffice/contacts/' + this.appConfig.apiPartnershipId, data).pipe(map((response) => response.body));
  }

  createContact(data: BackofficeContactsModel): Observable<any> {
    if (!data.id) {
      delete data.id;
    }

    if(!data.contactBuildingId || (data.contactBuildingId as any) == '') {
      delete data.contactBuildingId;
    }

    return this.http.post<any>(this.appConfig.api + 'backoffice/contacts/' + this.appConfig.apiPartnershipId, data).pipe(map((response) => response.body));
  }
}
